module.exports = __webpack_public_path__ + "static/media/table-wave.ae75679a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/common/table-wave.svg
// module id = 2802
// module chunks = 118